import React from "react";
import Skeleton from "../Skeletons/Skeleton";
import { Link } from "react-router-dom";
import Tooltip from "../Tooltip";
import { timezoneOffset } from "../../Services/time";
import { Language, User } from "@propellerads/icon";
import ManagerInfo from "Components/ManagerInfo";
import Translate from "../Translate";
import { createSendingClick } from "actions/sendings";
// @ts-ignore
import Header from "@propellerads/header";
// @ts-ignore
import Button, { BUTTON_TYPE } from "@propellerads/button";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import ROUTES from "Constants/routes";
import moment from "moment-timezone";
import useLegalInfo from "../../hooks/useLegalInfo";
import "./styles.scss";

interface INotixHeaderProps {
  isLoadingSites: boolean;
  sitesItems: Array<any>;
  shortLanguageTitle: string;
  sendingTotal: number;
  activeUsers: number;
  userTime: moment.Moment;
  languagesMenu: (lang: object) => React.ReactElement;
  userMenu: Array<React.ReactElement>;
}

const NotixHeader = (props: INotixHeaderProps) => {
  const {
    isLoadingSites,
    shortLanguageTitle,
    sendingTotal,
    activeUsers,
    userTime,
    languagesMenu,
    userMenu,
  } = props;

  useLegalInfo();

  const dispatch = useAppDispatch();
  const createSendingClickAction = () => dispatch(createSendingClick());

  const isAuthenticated = useAppSelector(
    (store) => store.authorize.isAuthenticated
  );
  const { status: createSendingsIsUnlocked } = useAppSelector(
    (store) => store.notixProfile
  );

  return (
    <>
      {isAuthenticated && (
        <>
          <ManagerInfo />

          {!isLoadingSites ? (
            <div className="Header__infoSubscribers">
              <div className="Header__sendingTotal">
                <div className="Header__label">
                  <div className="Header__labelStTop">
                    {<Translate tag="menu_counter-number-of" />}
                  </div>
                  <div className="Header__labelStBottom">
                    {<Translate tag="menu_counter-mailings" />}
                  </div>
                </div>
                <div className="Header__counterST">{sendingTotal}</div>
              </div>

              <div className="Header__divider" />

              <div className="Header__activeUsers">
                <div className="Header__label">
                  <div className="Header__labelAuTop">
                    {<Translate tag="menu_counter-you-have" />}
                  </div>
                  <div className="Header__labelAuBottom">
                    {<Translate tag="menu_counter-subscribers" />}
                  </div>
                </div>
                <div className="Header__counterAU">{activeUsers}</div>
              </div>
            </div>
          ) : (
            <>
              <Skeleton className="skeleton__header-button" />
              <div className="Header__divider" />
              <Skeleton className="skeleton__header-button" />
            </>
          )}
          {createSendingsIsUnlocked ? (
            <Link to={ROUTES.CREATE_SENDING}>
              <Button
                elementId="header__send_message"
                type={BUTTON_TYPE.PRIMARY}
                onClick={createSendingClickAction}
              >
                <Translate tag="menu_create-button" />
              </Button>
            </Link>
          ) : (
            <Tooltip
              id="create-sending-is-locked"
              tip={<Translate tag="sending_create_locked" />}
            >
              <Button
                elementId="header__send_message"
                type={BUTTON_TYPE.PRIMARY}
                onClick={createSendingClickAction}
                isDisabled={true}
              >
                <Translate tag="menu_create-button" />
              </Button>
            </Tooltip>
          )}

          <div>
            <div className="Header__time">
              <Tooltip
                id="tooltip-header__time"
                tip={<Translate tag="tooltip-header__time" />}
              >
                {userTime} ({timezoneOffset(new Date())})
              </Tooltip>
            </div>
          </div>
        </>
      )}

      <div className="Header__right-buttons">
        <Header.HeaderItem
          id="header_dropdown_languages--button"
          icon={<Language />}
          title={shortLanguageTitle}
          isRightDropdown
        >
          <Header.HeaderDropdown id="header_dropdown_languages--list">
            <Header.HeaderDropdownList items={languagesMenu} />
          </Header.HeaderDropdown>
        </Header.HeaderItem>

        {isAuthenticated && (
          <Header.HeaderItem
            id="header_dropdown_menu--button"
            leftDivider
            isRightDropdown
            icon={<User />}
          >
            <Header.HeaderDropdown id="header_dropdown_menu--list">
              <Header.HeaderDropdownList items={userMenu} />
            </Header.HeaderDropdown>
          </Header.HeaderItem>
        )}
      </div>
    </>
  );
};

export default NotixHeader;
